const App_Properties = [
    {
        Slide_ID: "HomeTest",
        Routes: ["/test", "/test/home", "/test/home/test"],
        Panels: {
            Left: {
                Enabled: false,
                State: "Expanded",
                Title: "",
                Toggle: false,
                Width: {
                    Expanded: "1000px",
                    Collapsed: "40px"
                }
            },
            Center: {
                Margins: true
            },
            Right: {
                Enabled: true,
                State: "Expanded",
                Title: "",
                Toggle: false,
                Width: {
                    Expanded: "400px",
                    Collapsed: "40px"
                }
            }
        },
        Ribbon: {
            Enabled: true
        },
        Properties: {
            Header_Title: "Home",
            Trigger_LoadingScreen: false,
            Window: {
                Title: {
                    Primary: "Digi-Rooms",
                    Secondary: "Home",
                    Separator: " | "
                }
            }
        }
    },
    {
        Slide_ID: "Home",
        Routes: ["/", "/home", "/Home"],
        Panels: {
            Left: {
                Enabled: false,
                State: "Expanded",
                Title: "",
                Toggle: false,
                Width: {
                    Expanded: "250px",
                    Collapsed: "40px"
                }
            },
            Center: {
                Margins: true
            },
            Right: {
                Enabled: true,
                State: "Expanded",
                Title: "",
                Toggle: false,
                Width: {
                    Expanded: "400px",
                    Collapsed: "40px"
                }
            }
        },
        Ribbon: {
            Enabled: false
        },
        Properties: {
            Header_Title: "Home",
            Trigger_LoadingScreen: false,
            Window: {
                Title: {
                    Primary: "Digi-Rooms",
                    Secondary: "Home",
                    Separator: " | "
                }
            }
        }
    },
    {
        Slide_ID: "Map",
        Routes: ["/map", "/map/view"],
        Panels: {
            Left: {
                Enabled: true,
                State: "Expanded",
                Title: "",
                Toggle: false,
                Width: {
                    Expanded: "250px",
                    Collapsed: "40px"
                }
            },
            Center: {
                Margins: false
            },
            Right: {
                Enabled: true,
                State: "Expanded",
                Title: "",
                Toggle: false,
                Width: {
                    Expanded: "400px",
                    Collapsed: "40px"
                }
            }
        },
        Ribbon: {
            Enabled: true
        },
        Properties: {
            Header_Title: "Interactive Map",
            Trigger_LoadingScreen: false,
            Window: {
                Title: {
                    Primary: "Digi-Rooms",
                    Secondary: "Interactive Map",
                    Separator: " | "
                }
            }
        }
    },
    {
        Slide_ID: "MapEditor",
        Routes: ["/map/edit", "/map/edit/add/building", "/map/edit/add/floor", "/map/edit/add/room"],
        Panels: {
            Left: {
                Enabled: true,
                State: "Expanded",
                Title: "",
                Toggle: false,
                Width: {
                    Expanded: "250px",
                    Collapsed: "40px"
                }
            },
            Center: {
                Margins: false
            },
            Right: {
                Enabled: true,
                State: "Expanded",
                Title: "",
                Toggle: false,
                Width: {
                    Expanded: "500px",
                    Collapsed: "40px"
                }
            }
        },
        Ribbon: {
            Enabled: true
        },
        Properties: {
            Header_Title: "Map Editor",
            Trigger_LoadingScreen: false,
            Window: {
                Title: {
                    Primary: "Digi-Rooms",
                    Secondary: "Map Editor",
                    Separator: " | "
                }
            }
        }
    },
    {
        Slide_ID: "MapEditor_Table",
        Routes: ["/map/edit/table"],
        Panels: {
            Left: {
                Enabled: false,
                State: "Expanded",
                Title: "",
                Toggle: false,
                Width: {
                    Expanded: "250px",
                    Collapsed: "40px"
                }
            },
            Center: {
                Margins: false
            },
            Right: {
                Enabled: true,
                State: "Expanded",
                Title: "",
                Toggle: false,
                Width: {
                    Expanded: "500px",
                    Collapsed: "40px"
                }
            }
        },
        Ribbon: {
            Enabled: false
        },
        Properties: {
            Header_Title: "Table View",
            Trigger_LoadingScreen: false,
            Window: {
                Title: {
                    Primary: "Digi-Rooms",
                    Secondary: "Map Editor Table View",
                    Separator: " | "
                }
            }
        }
    },
    {
        Slide_ID: "MapEditor_Bin",
        Routes: ["/map/edit/bin"],
        Panels: {
            Left: {
                Enabled: false,
                State: "Expanded",
                Title: "",
                Toggle: false,
                Width: {
                    Expanded: "250px",
                    Collapsed: "40px"
                }
            },
            Center: {
                Margins: false
            },
            Right: {
                Enabled: true,
                State: "Expanded",
                Title: "",
                Toggle: false,
                Width: {
                    Expanded: "500px",
                    Collapsed: "40px"
                }
            }
        },
        Ribbon: {
            Enabled: false
        },
        Properties: {
            Header_Title: "Bin",
            Trigger_LoadingScreen: false,
            Window: {
                Title: {
                    Primary: "Digi-Rooms",
                    Secondary: "Map Editor Bin View",
                    Separator: " | "
                }
            }
        }
    },
    {
        Slide_ID: "Schedule",
        Routes: ["/schedules", "/schedules/reserve"],
        Panels: {
            Left: {
                Enabled: false,
                State: "Expanded",
                Title: "",
                Toggle: false,
                Width: {
                    Expanded: "250px",
                    Collapsed: "40px"
                }
            },
            Center: {
                Margins: false
            },
            Right: {
                Enabled: true,
                State: "Expanded",
                Title: "",
                Toggle: false,
                Width: {
                    Expanded: "500px",
                    Collapsed: "40px"
                }
            }
        },
        Ribbon: {
            Enabled: true
        },
        Properties: {
            Header_Title: "Schedules",
            Trigger_LoadingScreen: false,
            Window: {
                Title: {
                    Primary: "Digi-Rooms",
                    Secondary: "Schedules",
                    Separator: " | "
                }
            }
        }
    },
    {
        Slide_ID: "ScheduleManager",
        Routes: ["/schedules/manage"],
        Panels: {
            Left: {
                Enabled: true,
                State: "Expanded",
                Title: "",
                Toggle: false,
                Width: {
                    Expanded: "500px",
                    Collapsed: "40px"
                }
            },
            Center: {
                Margins: true
            },
            Right: {
                Enabled: true,
                State: "Expanded",
                Title: "",
                Toggle: false,
                Width: {
                    Expanded: "500px",
                    Collapsed: "40px"
                }
            }
        },
        Ribbon: {
            Enabled: false
        },
        Properties: {
            Header_Title: "Manage Requests",
            Trigger_LoadingScreen: false,
            Window: {
                Title: {
                    Primary: "Digi-Rooms",
                    Secondary: "Manage Requests",
                    Separator: " | "
                }
            }
        }
    },
    {
        Slide_ID: "Reports",
        Routes: ["/reports", "/reports/view"],
        Panels: {
            Left: {
                Enabled: false,
                State: "Expanded",
                Title: "",
                Toggle: false,
                Width: {
                    Expanded: "250px",
                    Collapsed: "40px"
                }
            },
            Center: {
                Margins: true
            },
            Right: {
                Enabled: false,
                State: "Expanded",
                Title: "",
                Toggle: false,
                Width: {
                    Expanded: "250px",
                    Collapsed: "40px"
                }
            }
        },
        Ribbon: {
            Enabled: false
        },
        Properties: {
            Header_Title: "Reports",
            Trigger_LoadingScreen: false,
            Window: {
                Title: {
                    Primary: "Digi-Rooms",
                    Secondary: "Reports",
                    Separator: " | "
                }
            }
        }
    },
    {
        Slide_ID: "Reporter",
        Routes: ["/reports/monthlysched", "/reports/timetable", "/reports/roomutil", "/reports/floorutil", "/reports/reservation", "/reports/accounts", "/reports/usertrail", "/reports/log"],
        Panels: {
            Left: {
                Enabled: false,
                State: "Expanded",
                Title: "",
                Toggle: false,
                Width: {
                    Expanded: "250px",
                    Collapsed: "40px"
                }
            },
            Center: {
                Margins: false
            },
            Right: {
                Enabled: true,
                State: "Expanded",
                Title: "",
                Toggle: false,
                Width: {
                    Expanded: "500px",
                    Collapsed: "40px"
                }
            }
        },
        Ribbon: {
            Enabled: true
        },
        Properties: {
            Header_Title: "Reports",
            Trigger_LoadingScreen: false,
            Window: {
                Title: {
                    Primary: "Digi-Rooms",
                    Secondary: "Generate reports",
                    Separator: " | "
                }
            }
        }
    },
    {
        Slide_ID: "Accounts",
        Routes: ["/accounts", "/accounts/manage"],
        Panels: {
            Left: {
                Enabled: false,
                State: "Expanded",
                Title: "",
                Toggle: false,
                Width: {
                    Expanded: "250px",
                    Collapsed: "40px"
                }
            },
            Center: {
                Margins: false
            },
            Right: {
                Enabled: true,
                State: "Expanded",
                Title: "",
                Toggle: false,
                Width: {
                    Expanded: "500px",
                    Collapsed: "40px"
                }
            }
        },
        Ribbon: {
            Enabled: false
        },
        Properties: {
            Header_Title: "Accounts Management",
            Trigger_LoadingScreen: false,
            Window: {
                Title: {
                    Primary: "Digi-Rooms",
                    Secondary: "Accounts Management",
                    Separator: " | "
                }
            }
        }
    },
    {
        Slide_ID: "Templating",
        Routes: ["/templating", "/templating/manage"],
        Panels: {
            Left: {
                Enabled: false,
                State: "Expanded",
                Title: "",
                Toggle: false,
                Width: {
                    Expanded: "250px",
                    Collapsed: "40px"
                }
            },
            Center: {
                Margins: false
            },
            Right: {
                Enabled: false,
                State: "Expanded",
                Title: "",
                Toggle: false,
                Width: {
                    Expanded: "300px",
                    Collapsed: "40px"
                }
            }
        },
        Ribbon: {
            Enabled: true
        },
        Properties: {
            Header_Title: "System Templating",
            Trigger_LoadingScreen: false,
            Window: {
                Title: {
                    Primary: "Digi-Rooms",
                    Secondary: "System Templating",
                    Separator: " | "
                }
            }
        }
    },
    {
        Slide_ID: "User",
        Routes: ["/user", "/user/edit"],
        Panels: {
            Left: {
                Enabled: false,
                State: "Expanded",
                Title: "",
                Toggle: false,
                Width: {
                    Expanded: "250px",
                    Collapsed: "40px"
                }
            },
            Center: {
                Margins: true
            },
            Right: {
                Enabled: false,
                State: "Expanded",
                Title: "",
                Toggle: false,
                Width: {
                    Expanded: "300px",
                    Collapsed: "40px"
                }
            }
        },
        Ribbon: {
            Enabled: true
        },
        Properties: {
            Header_Title: "Manage account",
            Trigger_LoadingScreen: false,
            Window: {
                Title: {
                    Primary: "Digi-Rooms",
                    Secondary: "Manage account",
                    Separator: " | "
                }
            }
        }
    }
]

export default App_Properties;